<router-outlet>
</router-outlet>

<button ngxScrollTop [ngxScrollTopMode]="'classic'" class="my-custom-style" color="primary" mat-mini-fab>
  top
</button>
